import WRAP from "WRAP-JS";

/* eslint-disable */
WRAP.Renderer.GridValueExt = function() {
    WRAP.Renderer.call(this);

    this.draw = function(layer, content, conf, context, style, data, revision, dl) {
        WRAP.Geo.check(dl);
        
        if ( !content )
            return;
        
        var content_changed = false;
        var valid = true;
        if ( this.context_revision != revision.context ) {
            valid = false;
        }
        
        if ( this.content_revision != revision.content ) {
            layer.clear();
            content_changed = true;
            valid = false;
        }
        
        if ( this.conf_revision != revision.conf ) {
            valid = false;
        }
        
        if ( this.style_revision != revision.style ) {
            valid = false;
        }
        
        if ( valid )
            return;
        
        var s = conf.Attributes.style.default;
        if ( style && conf.Attributes.style[style] )
            s = conf.Attributes.style[style];
        if ( !s ) {
            layer.setStatus({status:"error", reason:"style definition error."});
            return;
        }
        
        layer.setStatus({status:"invalid", reason:"data load waiting."});
        
        var bounds = [];
        for ( var i = 0 ; i < context.tiles.length ; i++ ) {
            var tile = context.tiles[i];
            bounds.push({
                north:tile.bounds.north/60,
                south:tile.bounds.south/60,
                west:tile.bounds.west/60,
                east:tile.bounds.east/60,
                tile:tile,                          // for TMS
                blocksize:(s.min_blocksize||16)     // for TMS
            })
        }

        var precision = 360/(256*Math.pow(2,Math.floor(context.zoom))) * (s.min_blocksize || 40);
        var sampling = "decimation "+precision.toFixed(4);

        var gpv = this.getGridValue(data, 'data', bounds, content, sampling, layer);
        if ( !gpv )
            return;
        
        var overlap_range = s.overlap_range || 0;
        var cross_fade = parseFloat(conf.Attributes.cross_fade);
        var data_scale = conf.Attributes.data_scale || 1;
        var data_offset = conf.Attributes.data_offset || 0;
        var digit = (s.fractional_digits===undefined)?1:parseInt(s.fractional_digits);
        var offsetX = s.offset_x || 0;
        var offsetY = s.offset_y || 0;

        var continuous = content_changed?null:dl;
        layer.clear();

        var index = 0;
        for ( var y = 0 ; y < gpv.height ; y++ ) {
            var lat = gpv.latBase-y*gpv.latInterval;
            if ( gpv.latCoordinates )
                lat = gpv.latCoordinates[y];
            for ( var x = 0 ; x < gpv.width ; x++ ) {
                var lon = gpv.lonBase+x*gpv.lonInterval;
                if ( gpv.gap && x > gpv.gap )
                    lon = gpv.gapBase+(x-gpv.gap-1)*gpv.lonInterval;
                lon = (lon+360)%360;
                var v = gpv.data[index++];
                if ( isNaN(v) )
                    continue;
                var st = 1;
                if ( overlap_range ) {
                    var lon_index = Math.round(lon/gpv.lonInterval);
                    var sp0 = WRAP.Geo.getScreenPoint(new WRAP.Geo.Point(lat*60, lon*60));
                    var sp1 = WRAP.Geo.getScreenPoint(new WRAP.Geo.Point(lat*60, (lon+gpv.lonInterval)*60));
                    var sp2 = WRAP.Geo.getScreenPoint(new WRAP.Geo.Point(lat*60, (lon-gpv.lonInterval)*60));
                    if ( isNaN(sp0.x) || isNaN(sp1.x) || isNaN(sp2.x) )
                        continue;
                    var dx1 = Math.abs(sp1.x-sp0.x);
                    var dy1 = Math.abs(sp1.y-sp0.y);
                    var dx2 = Math.abs(sp2.x-sp0.x);
                    var dy2 = Math.abs(sp2.y-sp0.y);
                    var dx = dx1<dx1?dx1:dx2;
                    var dy = dx1<dx1?dy1:dy2;
                    var len = Math.sqrt(dx*dx+dy*dy);
                    var t = Math.floor(overlap_range/len);
                    var tt = (t && Math.floor(Math.log2(t))) || 0;
                    st = Math.pow(2,tt);
                    if ( (lon_index % st) )
                        continue;
                }
                if ( gpv.gapBase !== undefined ) {
                    var ll = lon;
                    while ( gpv.gapBase <= ll )
                        ll -= 360;
                    if ( gpv.gapBase <= ll+st*gpv.lonInterval*0.3 )    // 30% wrap_around gap margin
                        continue;
                }
                var text = (v*data_scale+data_offset).toFixed(digit);
                var feature = null;
                if ( continuous ) {
                    for ( var k = 0 ; k < continuous.length ; k++ ) {
                        var f = continuous[k];
                        var fs = f.style();
                        if ( fs.point[0] == lon && fs.point[1] == lat && fs.text == text && fs.fillStyle == s.color) {
                            feature = f;
                            continuous.splice(k, 1);
                            break; 
                        }
                    }
                }
                if ( !feature ) {
                    feature = new WRAP.Geo.Feature.Text({
                        point:[lon,lat],
                        text:text,
                        fontSize:14,
                        fillStyle:s.color,
                        offsetX:offsetX,
                        offsetY:offsetY,
                        align:'center'
                    });
                }
                if ( cross_fade && !content_changed )
                    feature.fadeIn(cross_fade);
                layer.addFeature(feature);
                feature.geo = {
                    geometry: {
                        type:"Point",
                        coordinates:[lon,lat]
                    },
                    properties: {
                        grid_value: text
                    }
                }
            }
        }
        if ( continuous && cross_fade ) {
            for ( var k = 0 ; k < continuous.length ; k++ ) {
                var f = continuous[k];
                f.fadeOut(cross_fade);
                layer.addFeature(f);
            }
        }

        this.context_revision = revision.context;
        this.content_revision = revision.content;
        this.conf_revision = revision.conf;
        this.style_revision = revision.style;
        if ( layer.getStatus().status != 'error' )
            layer.setStatus({status:"valid"});
        WRAP.Geo.invalidate();
    }
}
/* eslint-enable */
